export default __webpack_public_path__ + "static/media/P900_A_BD.1435f6e8.pdf";